import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card , Row, Col} from 'react-bootstrap';
import { Link,useParams} from 'react-router-dom';
import characterimg1 from '../../../assets/img/characterimg1.jpg'
import { getCharacterDetail } from '../../../api/taleService';
export default function ViewCharacter() {


  const [character, setCharacter] = useState({});
  const { characterId } = useParams(); 

  useEffect(() => {
    if (characterId) {
      fetchCharacter(characterId);
    }
  }, [characterId]);

  const fetchCharacter = (characterId) => {
    getCharacterDetail({ characterId })
      .then((response) => {
        if (response.data) {
          setCharacter(response.data); 
        }
      })
      .catch((error) => console.error("Error fetching user details", error));
  }

  
  const displayInfo = (info) => {
    return info ? info : "N/A";
  };

  const Talefiledata = [
    {
      id: 1,
      Title: 'Name',
      subtitle: character.character_name
      ,
    },
    {
      id: 2,
      Title: 'Description',
      subtitle: character.character_description?character.character_description:"N/A",
    },
    {
      id: 3,
      Title: 'Username',
      subtitle: character.username?character.username:"N/A",
    },
    {
      id: 4,
      Title: 'Character Setting',
      subtitle: character.character_setting,
    },
    // {
    //   id: 5,
    //   Title: 'Status',
    //   subtitle: <span className='Active badge'>{character.status}</span>,
    // },
];
  return (
    <React.Fragment>
      <Card>
        <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
          <h5>Character Details</h5>
          <Link className="btn btn-primary-light d-inline-flex align-items-center justify-content-center px-4 min_width140" to="/users">Back</Link>
        </Card.Header>
        <Card.Body className="taledtl_div mt-3">
          <Row>
            <Col md="4">
              <div className="talefile_box">
                <img className="talefile_img" src={characterimg1} alt="" />
              </div>
            </Col>
            <Col md="8">
              <div className="talefile_list">
              {Talefiledata.map((item) => (
                <div className="tablefilelist_grid">
                  <h4>{item.Title}</h4>
                  <p>{item.subtitle}</p>
                </div>
                ))}
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>   
    </React.Fragment>
  );

}